module.exports = __webpack_public_path__ + "assets/language-squares/zh-CN@2x-809b3f473d5dd941c7272f97d2e7399a.jpg";